// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrafficconfigGcpProperties } from './TrafficconfigGcpProperties';
import {
  TrafficconfigGcpPropertiesFromJSON,
  TrafficconfigGcpPropertiesFromJSONTyped,
  TrafficconfigGcpPropertiesToJSON,
  TrafficconfigGcpPropertiesToJSONTyped,
} from './TrafficconfigGcpProperties';
import type { V1CloudProvider } from './V1CloudProvider';
import {
  V1CloudProviderFromJSON,
  V1CloudProviderFromJSONTyped,
  V1CloudProviderToJSON,
  V1CloudProviderToJSONTyped,
} from './V1CloudProvider';
import type { TrafficconfigAwsProperties } from './TrafficconfigAwsProperties';
import {
  TrafficconfigAwsPropertiesFromJSON,
  TrafficconfigAwsPropertiesFromJSONTyped,
  TrafficconfigAwsPropertiesToJSON,
  TrafficconfigAwsPropertiesToJSONTyped,
} from './TrafficconfigAwsProperties';
import type { TrafficconfigTrafficConfigStatus } from './TrafficconfigTrafficConfigStatus';
import {
  TrafficconfigTrafficConfigStatusFromJSON,
  TrafficconfigTrafficConfigStatusFromJSONTyped,
  TrafficconfigTrafficConfigStatusToJSON,
  TrafficconfigTrafficConfigStatusToJSONTyped,
} from './TrafficconfigTrafficConfigStatus';
import type { TrafficconfigAzureProperties } from './TrafficconfigAzureProperties';
import {
  TrafficconfigAzurePropertiesFromJSON,
  TrafficconfigAzurePropertiesFromJSONTyped,
  TrafficconfigAzurePropertiesToJSON,
  TrafficconfigAzurePropertiesToJSONTyped,
} from './TrafficconfigAzureProperties';
import type { TrafficconfigDesiredTrafficState } from './TrafficconfigDesiredTrafficState';
import {
  TrafficconfigDesiredTrafficStateFromJSON,
  TrafficconfigDesiredTrafficStateFromJSONTyped,
  TrafficconfigDesiredTrafficStateToJSON,
  TrafficconfigDesiredTrafficStateToJSONTyped,
} from './TrafficconfigDesiredTrafficState';

/**
 *
 * @export
 * @interface TrafficconfigTrafficConfig
 */
export interface TrafficconfigTrafficConfig {
  /**
   *
   * @type {TrafficconfigAwsProperties}
   * @memberof TrafficconfigTrafficConfig
   */
  awsProperties?: TrafficconfigAwsProperties;
  /**
   *
   * @type {TrafficconfigAzureProperties}
   * @memberof TrafficconfigTrafficConfig
   */
  azureProperties?: TrafficconfigAzureProperties;
  /**
   *
   * @type {V1CloudProvider}
   * @memberof TrafficconfigTrafficConfig
   */
  cloudProvider?: V1CloudProvider;
  /**
   *
   * @type {TrafficconfigGcpProperties}
   * @memberof TrafficconfigTrafficConfig
   */
  gcpProperties?: TrafficconfigGcpProperties;
  /**
   *
   * @type {TrafficconfigDesiredTrafficState}
   * @memberof TrafficconfigTrafficConfig
   */
  privateTraffic?: TrafficconfigDesiredTrafficState;
  /**
   *
   * @type {TrafficconfigDesiredTrafficState}
   * @memberof TrafficconfigTrafficConfig
   */
  publicTraffic?: TrafficconfigDesiredTrafficState;
  /**
   *
   * @type {TrafficconfigTrafficConfigStatus}
   * @memberof TrafficconfigTrafficConfig
   */
  status?: TrafficconfigTrafficConfigStatus;
}

/**
 * Check if a given object implements the TrafficconfigTrafficConfig interface.
 */
export function instanceOfTrafficconfigTrafficConfig(
  value: object,
): value is TrafficconfigTrafficConfig {
  return true;
}

export function TrafficconfigTrafficConfigFromJSON(
  json: any,
): TrafficconfigTrafficConfig {
  return TrafficconfigTrafficConfigFromJSONTyped(json, false);
}

export function TrafficconfigTrafficConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigTrafficConfig {
  if (json == null) {
    return json;
  }
  return {
    awsProperties:
      json['aws_properties'] == null
        ? undefined
        : TrafficconfigAwsPropertiesFromJSON(json['aws_properties']),
    azureProperties:
      json['azure_properties'] == null
        ? undefined
        : TrafficconfigAzurePropertiesFromJSON(json['azure_properties']),
    cloudProvider:
      json['cloud_provider'] == null
        ? undefined
        : V1CloudProviderFromJSON(json['cloud_provider']),
    gcpProperties:
      json['gcp_properties'] == null
        ? undefined
        : TrafficconfigGcpPropertiesFromJSON(json['gcp_properties']),
    privateTraffic:
      json['private_traffic'] == null
        ? undefined
        : TrafficconfigDesiredTrafficStateFromJSON(json['private_traffic']),
    publicTraffic:
      json['public_traffic'] == null
        ? undefined
        : TrafficconfigDesiredTrafficStateFromJSON(json['public_traffic']),
    status:
      json['status'] == null
        ? undefined
        : TrafficconfigTrafficConfigStatusFromJSON(json['status']),
  };
}

export function TrafficconfigTrafficConfigToJSON(
  json: any,
): TrafficconfigTrafficConfig {
  return TrafficconfigTrafficConfigToJSONTyped(json, false);
}

export function TrafficconfigTrafficConfigToJSONTyped(
  value?: TrafficconfigTrafficConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_properties: TrafficconfigAwsPropertiesToJSON(value['awsProperties']),
    azure_properties: TrafficconfigAzurePropertiesToJSON(
      value['azureProperties'],
    ),
    cloud_provider: V1CloudProviderToJSON(value['cloudProvider']),
    gcp_properties: TrafficconfigGcpPropertiesToJSON(value['gcpProperties']),
    private_traffic: TrafficconfigDesiredTrafficStateToJSON(
      value['privateTraffic'],
    ),
    public_traffic: TrafficconfigDesiredTrafficStateToJSON(
      value['publicTraffic'],
    ),
    status: TrafficconfigTrafficConfigStatusToJSON(value['status']),
  };
}
